import React from 'react'
import { Modal as ModalWebUi, ModalDragHandle } from '@ztechapps/webui.modal'
import { MenuItemTrigger } from './MenuItemTrigger'
import { Modal } from 'react-bootstrap'
import { ApplyCancelButtons } from './ApplyCancelButtons'
import { ModalContent } from './ModalContent'

export const Layout = () => {
  return (
    <ModalWebUi trigger={MenuItemTrigger}>
      {({ toggleShowModal }) => (
        <>
          <ModalDragHandle>Manage Filters</ModalDragHandle>
          <Modal.Body>
            <ModalContent />
          </Modal.Body>
          <Modal.Footer>
            <ApplyCancelButtons toggleShowModal={toggleShowModal} />
          </Modal.Footer>
        </>
      )}
    </ModalWebUi>
  )
}
